import { render, staticRenderFns } from "./AxxessLteTopupPrices.vue?vue&type=template&id=fbaf8358&scoped=true&"
import script from "./AxxessLteTopupPrices.vue?vue&type=script&lang=js&"
export * from "./AxxessLteTopupPrices.vue?vue&type=script&lang=js&"
import style0 from "./AxxessLteTopupPrices.vue?vue&type=style&index=0&id=fbaf8358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaf8358",
  null
  
)

export default component.exports